module.exports = __webpack_public_path__ + "assets/img/img-chara-normal.16929081.svg";